<div [formGroup]="parentFormGroup" [ngClass]="componentClass" [class.red]="textColor == 'red'" [class.green]="textColor == 'green'" [class.black]="textColor =='black'" [class.no-label]="!label" [class.error]="isError" [class.disabled]="isDisabled" class="f-form_input">

   <input #input
           [type]="type"
           [formControlName]="controlName"
           [id]="controlName"
           class="theme-blue"
           [name]="controlName"
           [attr.placeholder]="placeholder"
           [attr.required]="isRequired ? '' : null"
           (input)="onSearch($event)"
           bsDaterangepicker
           [bsConfig]="{ isAnimated: true,
                          adaptivePosition: true,
                          containerClass: 'theme-dark-blue',
                          showWeekNumbers:false }"/>
    <label class="label" [for]="controlName" [innerHTML]="label" *ngIf="label"></label>
  </div>
